//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('dataImps', {
//        templateUrl: 'views/components/views/dataImps/dataImps.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ttGridFactory', function (stateService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_dataimps_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setLoadDataFunction({
//                    method: 3169,
//                    parameters: {}
//                })
//                .setCustomToolbarButtons([{
//                    name: 'dataimps_new',
//                    text: 'dataimps_new',
//                    func: () => stateService.go('dataimp', { dataimp_keyno: '0' }),
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);

//            // #endregion VARIABLES & DEFINITIONS
            
//        }]
//    });
//})();
